import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OptionsList } from 'src/app/models/optionsList.model';
import { Question } from 'src/app/models/question.model';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { filter, map } from 'rxjs';
import { AnswersStore } from 'src/app/store/answers-store';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { Answer } from 'src/app/models/Answer.model';
import { toSignal } from '@angular/core/rxjs-interop';
import { EQuestionType } from 'src/app/models/questionType.model';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';


@Component({
    selector: 'que-mark-question-display',
    imports: [CommonModule, ReactiveFormsModule, TranslateDirective, TranslatePipe],
    templateUrl: './mark-question-display.component.html',
    styleUrls: ['./mark-question-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MarkQuestionDisplayComponent {
  @Input()
  question?: Question;
  @Input() modularId?: number;
  @Input() modularOrder?: number;
  optionsListDetails?: OptionsList;
  @Input()
  isSub: boolean = false;
  @Input()
  isRequierd?: boolean;
  @Input() viewAnswer = false;
  myAnswer?: Answer;
  answer = new FormControl();
  #answerStore = inject(AnswersStore);

  #questionnaireStore = inject(QuestionnaireStore);
  isNotUser$ = this.#questionnaireStore.isUser$.pipe(map(x => !x));
  isDisableSignal$ = toSignal(this.isNotUser$);

  ngOnInit(): void {
    this.answer.setValidators(this.question?.requierd ? Validators.required : null);

    this.optionsListDetails = this.question?.optionsList;
    //  this.isNotUser$.subscribe((isNotUser) => {
    //    if (isNotUser) {
    //      this.answer.disable();
    //    } else {
    //      this.answer.enable();
    //    }
    //  });
    this.answer.valueChanges.subscribe(
      ans => {
        // var option = this.optionsListDetails?.answerOptionItem?.filter(op => op.id == ans);
        this.#answerStore.updateAnswer({ id: 0, questionId: this.question?.id ?? 0, questionType: this.question?.type.id, optionItemGuid: ans!, isValid: this.answer.valid })
      });
    this.#answerStore.answers$.pipe(map(arr => arr.find(ans => ans.questionId == this.question?.id))).subscribe(x => {
      if (x) {
        this.myAnswer = x;
        this.answer.setValue(x.optionItemGuid ?? 0, { emitEvent: false });
      }
    }).unsubscribe();

  }
  chooseOption(guid: string, name: string) {
    if (this.answer.value == guid) {
      if (!!this.question?.isFilterField) {
        this.#answerStore.updateMainAnswerAndSync('');
      }
      this.answer.setValue(null);
    }
    else {
      if (!!this.question?.isFilterField) {
        this.#answerStore.updateMainAnswerAndSync(name);
      }
      this.answer.setValue(guid);
    }
  }
}
